import { RESET_DB } from 'actions/orm'
import {
  GET_TARGET_SEGMENTS_SUCCESS,
  GET_TARGET_SEGMENT_SUCCESS,
  ResolvedAction,
} from 'actions/targetSegments'
import { attr, fk, Model, ModelType } from 'redux-orm'

export type SegmentType = 'global' | 'merchant' | 'user_list'

export type SegmentState = 'visible' | 'hidden' | 'requires_approval' | 'draft'

export type SegmentStatus = 'active' | 'pending' | 'review' | null

export interface SegmentMerchantUser {
  id: number
  first_name: string
  last_name: string
  email: string
}

export type SegmentRuleVisualizationData =
  | string
  | Record<string, unknown>
  | unknown[]

export interface Fields {
  id: number
  merchant_id: number
  merchant_user_id: number
  name: string
  description: string
  category: string
  subcategory: string
  type: SegmentType
  count: number
  state: SegmentState
  ai_generated?: boolean
  status?: SegmentStatus
  rules?: Record<string, unknown> | string | null
  created_at?: string
  merchant_user?: SegmentMerchantUser | null
  rule_visualization_data?: SegmentRuleVisualizationData | null
  customer_behaviour_text?: string
  automation_text?: string
  one_time_text?: string
}

// @ts-ignore
export default class TargetSegment extends Model<typeof TargetSegment, Fields> {
  static modelName: string = 'TargetSegment'

  static get fields(): Record<string, unknown> {
    return {
      id: attr(),
      merchant_id: fk('Merchant', 'targetSegments'),
      merchant_user_id: fk({
        to: 'MerchantUser',
        as: 'merchant_user',
        relatedName: 'targetSegments',
      }),
      name: attr(),
      description: attr(),
      state: attr(),
      ai_generated: attr(),
      status: attr(),
      rules: attr(),
      category: attr(),
      subcategory: attr(),
      type: attr(),
      count: attr(),
      created_at: attr(),
      rule_visualization_data: attr(),
      customer_behaviour_text: attr(),
      automation_text: attr(),
      one_time_text: attr(),
    }
  }

  /* eslint-disable no-use-before-define */
  static reducer(
    action: ResolvedAction | { type: typeof RESET_DB },
    // @ts-ignore
    TargetSegment: ModelType<TargetSegment>
  ) {
    /* eslint-disable no-use-before-define */
    switch (action.type) {
      case GET_TARGET_SEGMENTS_SUCCESS:
        action.payload.data.target_segments.forEach(segment => {
          return TargetSegment.upsert(segment)
        })
        break
      case GET_TARGET_SEGMENT_SUCCESS:
        TargetSegment.upsert(action.payload.data.target_segment)
        break
      case RESET_DB:
        TargetSegment.all().delete()
        break
      default:
        break
    }
  }
}
